/** Anmeldung */

export default {
  title: 'Anmeldung',
  username: 'Benutzername',
  password: 'Passwort',
  remember: 'Angemeldet bleiben',
  submit: 'Anmelden',
  forgot: 'Passwort vergessen?',
  register: 'Registrieren',
  validation: {
    username: {
      required: 'Bitte geben Sie Ihren Benutzernamen ein'
    },
    password: {
      required: 'Bitte geben Sie Ihr Passwort ein'
    }
  },
  error: {
    invalid: 'Ungültige Anmeldedaten',
    server: 'Serverfehler, bitte versuchen Sie es später erneut'
  },
  label: {
    code: 'SMS-Anmeldung',
    pswd: 'Passwort-Anmeldung'
  },
  phone: 'Telefonnummer',
  code: '{type}-Verifizierung',
  sms: 'SMS',
  img: 'Bild',
  getCode: 'Senden',
  login: 'Anmelden',
  // Händler auswählen
  choose: 'Händler auswählen',
  // Hinweise
  agree: 'Nicht registrierte Telefonnummern werden automatisch registriert. Häkchen bedeutet Zustimmung und Akzeptanz',
  agreement: '《Händlerplattform-Nutzervereinbarung》',
  second: 'Sek.',
  // WeChat-Anmeldung
  wx: 'WeChat-Anmeldung',
  // Aktivitätsverwaltungsplattform
  activity_platform: {
    title: 'Aktivitätsverwaltungsplattform',
    subtitle: 'Von einfach bis komplex, endlose Variationen und Einstellungen für Ihre Aktivitätsanforderungen',
    features: [
      'Veröffentlichung großer Aktivitäten durch mehrere Runden und Kategoriegruppen',
      'Erhöhung der Sichtbarkeit Ihrer Aktivitäten durch Beliebtheitsranglisten',
      'Erreichung vielfältiger Werbung durch Anzeigenladung',
      'Präzise Auswahl der besten Teilnehmer durch mehrdimensionale Bewertung',
      'Präsentation farbenfroher Szenen durch Bild- und Video-Uploads'
    ]
  },
  // Bewertung und Aufstieg
  evaluation: {
    title: 'Bewertung und Aufstieg',
    subtitle: 'Mehrdimensionale Bewertung für die gerechteste und formellste Auswahl',
    features: [
      'Erstellung mehrdimensionaler Bewertungsschemata für verschiedene Gruppen, zusammengesetzte Auswahl',
      'Wahl zwischen Bewertung und Beurteilung',
      'Mehrere Juroren bewerten und punkten gleichzeitig für faire Autorität',
      'Ein-Klick-Operation für Teilnehmerauswahl, Aufstieg und Ausschluss',
      'Erstellung von Zertifikaten und Ranglisten für herausragende Teilnehmer'
    ]
  },
  // Wunderbare Momente
  moments: {
    title: 'Wunderbare Momente',
    subtitle: 'Aufzeichnung wertvoller Momente in Aktivitäten durch Bilder und Videos',
    features: [
      'Upload von Bildern oder Videos, Veröffentlichung auf Mobilgeräten als Erinnerungen an wunderbare Momente',
      'Effiziente Verwaltung durch Tags und Kategorien von Bildern und Videos',
      'Download von Bildern und Videos für Benutzer zum dauerhaften Speichern von Höhepunkten'
    ]
  },
  // Beliebtheitsranglisten
  popularity: {
    title: 'Beliebtheitsranglisten',
    subtitle: 'Perfekte Darstellung der Aktivitätsbeliebtheit durch Ranglisten',
    features: [
      'Like-Ranglisten, eine Stimme pro Person zeigt hohe Aktivitätsbeliebtheit',
      'Geschenk-Ranglisten, leisten Sie einen Beitrag zur Unterstützung beliebter Teilnehmer',
      'Mehrstufige Ranglisten zeigen unterschiedliche Beliebtheit in verschiedenen Phasen',
      'Gruppen-Ranglisten zeigen beliebte Teilnehmer in verschiedenen Gruppen'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/de/login.js